<template>
  <div>
    <loading-spinner v-if="loading" />
    <template v-else>
      <h3 v-label-key="'SCREENSAVERS'">Screensavers</h3>
      <b-button
        variant="outline-primary"
        v-if="level === 'distributor'"
        @click="createScreensaver"
      >
        <span v-label-key="'SCREENSAVER_CREATE'">Create Screensaver</span>
      </b-button>
      <p v-label-key="'SCREENSAVER_DESCRIPTION'">
        Screensavers are only displayed on cutting machines with LCD screen.
        Screensavers can be applied to all the chains of a
        distributor/subdistributor.
      </p>

      <b-table-simple>
        <b-tr v-for="screensaver in screensavers" :key="screensaver.id">
          <b-td>
            <h3>{{ screensaver.name }}</h3>
            <details>
              <summary>
                <span v-label-key="'TEMPLATE_TYPES_ENABLED_CHAINS'"
                  >Chains Enabled
                </span>
                <b-badge
                  pill
                  variant="success"
                  v-if="chainEnabledList(screensaver)"
                  >{{ chainEnabledList(screensaver).length }}</b-badge
                >
              </summary>
              <ul>
                <li
                  v-for="chain in chainEnabledList(screensaver)"
                  :key="`enabled-${screensaver.id}-${chain.id}`"
                >
                  <router-link :to="{ name: 'chain-detail', params: chain }">
                    {{ chain.name }}
                  </router-link>
                </li>
              </ul>
            </details>
          </b-td>
          <b-td class="text-right">
            <b-button
              v-if="level === 'distributor'"
              variant="outline-primary"
              @click="editScreensaver(screensaver)"
            >
              <span v-label-key="'SCREENSAVER_EDIT'">Edit Screensaver</span>
            </b-button>
            <div></div>
            <app-chain-selector
              :chain-ids="chainEnabledIds(screensaver)"
              @select="saveChainScreensaver(screensaver, $event)"
            >
              <b-button variant="outline-primary">
                <span v-label-key="'CHAIN_SELECTOR_SELECT_CHAINS'"
                  >Select Chains</span
                >
              </b-button>
            </app-chain-selector>
          </b-td>
        </b-tr>
      </b-table-simple>
    </template>
  </div>
</template>
<script>
import $api from '@/services/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import AppChainSelector from '@/components/ChainSelector';

import { mapState } from 'vuex';

export default {
  name: 'ScreensaverListTab',
  components: {
    LoadingSpinner,
    AppChainSelector,
  },
  computed: {
    ...mapState('global', {
      chains: 'chains',
      params: 'params',
    }),
    level() {
      if (this.$route.path.includes('subdi')) return 'subdistributor';
      return 'distributor';
    },
    chainEnabledList() {
      return screensaver => {
        if (!this.chains || !screensaver) return [];
        return this.chains.filter(chain => {
          return screensaver.id === chain.screensaver_id;
        });
      };
    },
    chainEnabledIds() {
      return screensaver => {
        return this.chainEnabledList(screensaver).map(chain => chain.id);
      };
    },
  },

  data() {
    return {
      screensavers: null,
      loading: false,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.loading = true;
      try {
        this.screensavers = await $api.get(
          `/v1/dashboard/screensavers/distributors/${this.params.distributor_id}`
        );
      } catch (e) {}
      this.loading = false;
    },
    createScreensaver() {
      this.editScreensaver({ id: '' });
    },
    editScreensaver(screensaver) {
      this.$router.push({
        name: 'distributor-screensavers-editor-tab',
        query: { id: screensaver.id },
      });
    },
    async saveChainScreensaver(screensaver, chainIds) {
      this.loading = true;
      try {
        await $api.put(
          `/v1/dashboard/screensaverchains/${screensaver.id}/${this.level}s/${this.$route.params.id}`,
          chainIds
        );
      } catch (e) {
        alert('Error saving');
      }
      this.reloadChains();
    },
    async reloadChains() {
      try {
        const { distributor_id, subdistributor_id } = this.params;
        const payload = {
          distributor_id,
        };
        if (subdistributor_id) payload.subdistributor_id = subdistributor_id;
        await this.$store.dispatch('global/getChains', payload);
      } catch (e) {
        alert('Error reloading the list of chains.  Please refresh');
      }
      this.loading = false;
    },
  },
};
</script>
